<!-- eslint-disable vue/multi-word-component-names -->
<!-- 组件文件 -->
<template>
  <div class="describe">
     <div class="describeCont alc" v-for="(item, index) in describeList" :key="index">
      <div class="describeTxt">
        <h3>{{ item.title }}</h3>
        <p>{{ item.cont }}</p>
      </div>
      <img v-if="currentLocale === 'zh'" :src="require(`../assets/introduction${index + 1}.png`)" />
      <img v-else :src="require(`../assets/introductionEn${index + 1}.png`)" />
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    describeList () {
      return [
        {
          title: this.$t('describe.record'),
          cont: this.$t('describe.recordIn')
        },
        {
          title: this.$t('describe.summary'),
          cont: this.$t('describe.summaryIn')
        },
        {
          title: this.$t('describe.map'),
          cont: this.$t('describe.mapIn')
        }
      ]
    },
    // 使用计算属性获取当前语言，确保响应式
    currentLocale () {
      return this.$i18n.locale
    }
  },
  mounted () {
    console.log('this.$i18n.locale', this.$i18n.locale)
  }
}
</script>

<style scoped>
/* 原有样式保持不变 */
.describeCont {
  margin-bottom: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.describeTxt {
  width: 50%;
}

.describeCont img {
  width: 40%;
}

.describeCont h3 {
  font-size: 20px;
  color: #3278FD;
  font-weight: bold;
  margin-bottom: 15px;
}

@media (max-width: 800px) {
  .describeCont {
    margin: 30px 0;
    flex-direction: column;
  }

  .describeTxt {
    width: 100%;
  }

  .describeCont h3 {
    font-size: 16px;
    text-align: center;
  }

  .describeCont p {
    font-size: 14px;
    margin: 10px 0 20px;
  }
}
</style>

<style scoped>
.describeCont {
  margin-bottom: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.describeTxt {
  width: 50%;
}

.describeCont img {
  width: 40%;
}

.describeCont h3 {
  font-size: 20px;
  color: #3278FD;
  font-weight: bold;
  margin-bottom: 15px;
}

@media (max-width: 800px) {
  .describeCont {
    margin: 30px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .describeTxt {
    width: 100%;
  }

  .describeCont h3 {
    font-size: 16px;
    text-align: center;
  }

  .describeCont p {
    font-size: 14px;
    margin: 10px 0 20px;
  }
}
</style>
